import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetActiveElevatorsQueryResponse, GetActiveElevators400, GetActiveElevators401, GetActiveElevators403, GetActiveElevators404, GetActiveElevators410, GetActiveElevators422, GetActiveElevators429, GetActiveElevators500 } from "../types/GetActiveElevators";

export const getActiveElevatorsQueryKey = () =>     [{url:`/api/credit-flow-backend/v1/elevators/view_for-advance-calculate`}] as const;
      export function getActiveElevatorsQueryOptions <TData = GetActiveElevatorsQueryResponse, TError = GetActiveElevators400 | GetActiveElevators401 | GetActiveElevators403 | GetActiveElevators404 | GetActiveElevators410 | GetActiveElevators422 | GetActiveElevators429 | GetActiveElevators500>(options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getActiveElevatorsQueryKey();

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/credit-flow-backend/v1/elevators/view_for-advance-calculate`,
              
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/credit-flow-backend/v1/elevators/view_for-advance-calculate
 */

export function useGetActiveElevators <TData = GetActiveElevatorsQueryResponse, TError = GetActiveElevators400 | GetActiveElevators401 | GetActiveElevators403 | GetActiveElevators404 | GetActiveElevators410 | GetActiveElevators422 | GetActiveElevators429 | GetActiveElevators500>(options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getActiveElevatorsQueryKey();

  const query = useQuery<TData, TError>({
    ...getActiveElevatorsQueryOptions<TData, TError>(clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
